<template>
    <div class="clear-container">
        <Nav :leftShow="true" @leftClick="clickLeft" title="法桐果毛飘絮治理路线及时段"></Nav>
        <div class="list-header">
            <div class="date-list">
                <div :class="['date-item', {'active': index == activeItem}]" v-for="(item, index) in dateList" @click="selectItem(index)">
                    <span class="item-month">{{item.month}}</span>
                    <span class="item-day">{{item.day}}</span>
                </div>
            </div>
            <!-- <div class="desc">
                4月1日晚主城区已出动工作人员<span>157</span>人，喷雾车、洒水车、清扫车等共计<span>21</span>台车，对<span>35</span>条街道进行了治理。
            </div> -->
        </div>
        <div class="city-list">
            <div class="city-item" v-for="item in detailList">
                <div class="head">
                    <div class="h-left">
                        <div class="img">
                            <img src="../home/images/clear.png" alt="">
                        </div>
                        <span class="city-name">{{item.title}}</span>
                    </div>
                    <div class="h-right">
                        <p class="time">{{item.time}}</p>
                    </div>
                </div>
                <div class="content">
                    {{item.road}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Nav from '../../common/Nav.vue'
export default {
    components: {
        Nav
    },
    data() {
        return {
            activeItem: 0,
            dateList: [],
            detailList: [],
            basePath: '/national-service-js', //本地路径
        }
    },
    methods: {
        selectItem(index) {
            console.log(index)
            this.activeItem = index
            this.getDetail()
        },
        clickLeft() {
            this.$router.push('/')
        },
        getTimeList() {
            var vm = this
            $.ajax({
                type: 'get',
                url: vm.basePath +  '/road/query7Time?r=' + Math.random(),
                dataType: 'json',
                success: function(res) {
                    console.log(res)
                    vm.dateList = [];
                    res.map(item => {
                        let n = item.indexOf('月');
                        vm.dateList.push({
                            month: item.substring(0, n + 1),
                            day: item.substring(n+1)
                        })
                    })
                    vm.sortDate(vm.dateList)
                    vm.getDetail()
                },
                error: function(xhr) {
                    console.info('请求失败！')
                }
            })
        },
        sortDate(dateList) {
            let status = false;
            dateList.map(item => {
                let month = parseInt(item.month.substring(0, item.month.length - 1))
                let day = parseInt(item.day.substring(0, item.day.length - 1))
                if (month === 12) {
                    // 含有12月份
                    status = true
                }
                item.weight = month*30 + day
                // 如果存在12月和1月份，1月份权重加一年，排在后面
                if (status) {
                    if (month === 1) {
                        item.weight += 12*30
                    }
                }
            })
            dateList.sort((a, b) => a.weight - b.weight)
            dateList.map(item => {
                console.log(item)
            })
        },
        // 获取详细数据
        getDetail() {
            var vm = this
            let params = {
                time: this.dateList[this.activeItem].month + this.dateList[this.activeItem].day
            }
            $.ajax({
                type: 'get',
                url: vm.basePath + '/road/getRoadImportList?r=' + Math.random(),
                data: params,
                dataType: 'json',
                success: function(res) {
                    console.log(res)
                    vm.detailList = [];
                    for (let key in res) {
                        let n = res[key][0].route.indexOf('号');
                        vm.detailList.push({
                            title: key,
                            time: res[key][0].timeInterval,
                            road: res[key][0].route.substring(n+2),
                        })
                    }
                },
                error: function(xhr) {
                    console.info('请求失败！')
                }
            })
        }
    },
    created() {
        this.getTimeList();
    }
}
</script>

<style scoped lang="less">
    @import '~@/components/content/home/css/common.less';
    .clear-container {
        font-size: 18px;
        .list-header {
            background: url(../home/images/clear-bg.png) top/100% auto no-repeat;
            padding: 10px;
            .desc {
                padding: 4px;
                line-height: 30px;
                // letter-spacing: 0.5px;
                text-align: justify;
                span {
                    color: @bgColor;
                    font-size: bold;
                    font-size: 20px;
                    padding: 0 2px;
                }
            }
        }
    }
    .city-list {
        background: #F6F6F9;
        .city-item {
            background: #fff;
            margin-bottom: 30px;
            .head {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                border-bottom: 2px solid #E7E6EB;
                padding: 8px 10px;
                box-sizing: border-box;
                .h-left {
                    display: flex;
                    justify-content: flex-start;
                    align-items: flex-end;
                    font-weight: bold;
                    // font-size: 20px;
                    line-height: 22px;
                    .img {
                        margin-right: 4px;
                        margin-bottom: 4px;
                        width: 19px;
                        height: 19px;
                        img {
                            width: 100%;
                        }
                    }
                }
                .h-right {
                    .time {
                        color: #AAA8B5;
                    }
                }
            }
            .content {
                padding: 10px 10px 15px 40px;
                line-height: 28px;
                letter-spacing: 1px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/content/clear/Clear.vue